// extracted by mini-css-extract-plugin
export default {"outerDiv":"ErrorPage_outerDiv__eM0Ev","innerDiv":"ErrorPage_innerDiv__jZKy1"};